import React from "react";
import { cn } from "../lib/utils";
import {
  FaLaptopCode,
  FaShieldAlt,
  FaCloud,
  FaSyncAlt,
  FaHeadset,
  FaSearch,
  FaChartBar,
  FaRegSmileBeam,
} from "react-icons/fa";

const FeaturesSectionDemo = () => {
  const features = [
    {
      title: "Custom-Built, Hand-Coded Websites",
      description:
        "Your website is hand-coded using modern Static Site Generators (SSG) for superior performance and security. Every detail is tailored to your brand, ensuring a unique online presence.",
      icon: <FaLaptopCode />,
    },
    {
      title: "Built for Security and Performance",
      description:
        "By leveraging SSG technology, your website is inherently more secure, eliminating vulnerabilities like server-side attacks, while optimizing for blazing-fast load times.",
      icon: <FaShieldAlt />,
    },
    {
      title: "Reliable Hosting with 99.99% Uptime",
      description:
        "Enjoy secure, high-performance hosting with 99.99% uptime, managed entirely by me to ensure your site is always online and running smoothly.",
      icon: <FaCloud />,
    },
    {
      title: "Unlimited Edits and Updates",
      description:
        "Make unlimited changes to your content, layout, or features—whenever you need them—with my subscription plan, ensuring your site stays fresh and relevant.",
      icon: <FaSyncAlt />,
    },
    {
      title: "Comprehensive Support",
      description:
        "From minor tweaks to major adjustments, I’m always available to help. Think of me as your personal web developer on call.",
      icon: <FaHeadset />,
    },
    {
      title: "Advanced On-Page SEO",
      description:
        "Optimized content, meta tags, structured data, and image alt texts to improve your website’s search engine visibility and drive more traffic.",
      icon: <FaSearch />,
    },
    {
      title: "Privacy-Forward Analytics",
      description:
        "Powered by Plausible, you’ll receive actionable analytics reports without compromising user privacy, helping you make data-driven decisions.",
      icon: <FaChartBar />,
    },
    {
      title: "Peace of Mind",
      description:
        "With secure hosting, unlimited support, and ongoing updates, you can focus on growing your business while I handle your online presence.",
      icon: <FaRegSmileBeam />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  relative z-10 py-10 max-w-7xl mx-auto">
      {features.map((feature, index) => (
        <Feature key={feature.title} {...feature} index={index} />
      ))}
    </div>
  );
};

const Feature = ({ title, description, icon, index }) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:border-r  py-10 relative group/feature dark:border-neutral-800 ",
        (index === 0 || index === 4) && "lg:border-l dark:border-neutral-800",
        index < 4 && "lg:border-b dark:border-neutral-800"
      )}
    >
      {index < 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      {index >= 4 && (
        <div className="opacity-0 group-hover/feature:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      <div className="mb-4 relative z-10 px-10 text-brand dark:text-neutral-400">
        {icon}
      </div>
      <div className="text-lg font-bold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 group-hover/feature:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover/feature:bg-brand transition-all duration-200 origin-center" />
        <h3 className="group-hover/feature:translate-x-2 transition duration-200 inline-block text-gray-700 dark:text-neutral-100">
          {title}
        </h3>
      </div>
      <p className="text-sm text-neutral-600 dark:text-neutral-300 max-w-xs relative z-10 px-10">
        {description}
      </p>
    </div>
  );
};

export default FeaturesSectionDemo;
